import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { FeaturedCategoryDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/featuredcategory/featuredcategorydto';
import { FeaturedCategoriesResponse } from 'src/com/sixdee/crbtportal/core/api/featuredcategories/featuredcategoriesresponse';
import { FeaturedCategoriesRequestImpl } from 'src/com/sixdee/crbtportal/core/api/featuredcategories/featuredcategoriesrequest';
// import { TextTransform } from '../../../toolkit/texttransform/texttransform';
import { FeaturedCategoryComponent } from './featuredcomponent';

export interface FeaturedCategoryAPIModel extends APIModel
{
    getFeaturedCategories(): void;
    getFeaturedCategoriesBasedOnTitle(id: string, title: string): void;
}

export class FeaturedCategoryAPIModelImpl extends APIModelImpl implements FeaturedCategoryAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    getFeaturedCategories(): void 
    {   
        let featuredCategories = this.getContext().getConfigurationSettings()
        .getPropertyBasedOnLanguage("FeaturedCategory").split("|");

        let featuredCategoryMap: Map<string, string> = new Map<string, string>();
        featuredCategories.forEach((categories: string) =>
        {
            console.log("-------featuredCategories: " + categories);
            let releases = categories.split(",");

            console.log("------releasestitle" + releases[1]);
            console.log("------releasesid" + releases[0]);
            console.log("-------------------------------------");
            featuredCategoryMap.set(releases[0], releases[1]);
        });
    //    let arrayMap = [...featuredCategoryMap];

    //    this.getFeaturedCategoriesBasedOnTitle(arrayMap[0][1], arrayMap[0][0]);
        
        (this.getAPIModelHandler() as FeaturedCategoryComponent).setFeaturedCategoryMap(featuredCategoryMap);
    }   

    
    getFeaturedCategoriesBasedOnTitle(id: string, title: string): void 
    {
        console.log("getFeaturedCategoriesBasedOnTitle() invoked: " + id + "title: " + title);

         let featuredCategoryDto = new FeaturedCategoryDtoImpl();
         featuredCategoryDto.setIdentifier(id);
         featuredCategoryDto.setTitle(title);
         featuredCategoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn() === "" ? "0" : this.getContext().getUserContext().getMsisdn());
         featuredCategoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
 
         this.getAPIProcesssorFactory().getFeaturedCategoriesAPIProcessorFactory()
                     .getFeaturedCategories()
                  .success((featuredCategoriesResponse: FeaturedCategoriesResponse)=>
                  {
                    featuredCategoryDto.setListOfTones(featuredCategoriesResponse.getFeaturedCategoryDto().getListOfTones());

                     this.getAPIModelHandler().onSuccess(featuredCategoriesResponse.getAPIFeature(), 
                     featuredCategoriesResponse.getDescription(), featuredCategoryDto); 
                  })
                  .failure((featuredCategoriesResponse : FeaturedCategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(featuredCategoriesResponse.getAPIFeature(), 
                      featuredCategoriesResponse.getDescription(), undefined);
                    
                  })
                  .execute(new FeaturedCategoriesRequestImpl(featuredCategoryDto));
    } 
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/featuredcategoryapimodel.ts